var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenNewTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33569",
    "data-name": "Group 33569",
    transform: "translate(126 136) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(108 118)",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(343.73 227.903) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72245",
    "data-name": "Path 72245",
    d: "M225.931,92.9h-4a3.2,3.2,0,0,0-3.2,3.2v9.6a3.2,3.2,0,0,0,3.2,3.2h9.6a3.2,3.2,0,0,0,3.2-3.2v-4a.8.8,0,1,0-1.6,0v4a1.6,1.6,0,0,1-1.6,1.6h-9.6a1.6,1.6,0,0,1-1.6-1.6V96.1a1.6,1.6,0,0,1,1.6-1.6h4a.8.8,0,1,0,0-1.6ZM232,94.5h-2.869a.8.8,0,0,1,0-1.6h4.8a.8.8,0,0,1,.8.8v4.8a.8.8,0,1,1-1.6,0V95.634l-5.834,5.834a.8.8,0,1,1-1.131-1.131Z",
    fill: "#5076ba",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewTab);
export default __webpack_public_path__ + "static/media/open-new-tab.75f0e5b122b5ac0751b173747fce13d6.svg";
export { ForwardRef as ReactComponent };